import React, { Component } from 'react';
import ProductTypeOperator from '../Dashboard/ProductTypeOperator';
import OperatorComparison from '../Dashboard/OperatorComparison';
import SalePerson from './SalePerson';
import TopCounter from './TopCounter';
import LowestCounter from './LowestCounter';
import { dateFormatter } from "../../helper/func";
import Multiselect from 'multiselect-react-dropdown';
import { GetProductTypeList } from '../../api/ProductType';
import { GetOperatorList } from '../../api/Operator';
import { connect } from 'react-redux';
import { LoadingSpinner } from '../../components';
import { GetCompanyInfoById } from '../../api/CompanyInfo';
import defaultLogo from '../../assets/img/avator/company-defaultLogo.png'
import {
  Row, Col, Button, Label, FormGroup
} from "reactstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../scss/style.css';

class Dashboard extends Component {

  static routeName = '/report/dashboard';
  constructor(props) {
    super(props);
    this.state = {
      logo: "",
      companyName: "",
      startDate: new Date(),
      endDate: new Date(),
      ProductTypeList: [],
      OperatorList: [],
      paramType: [],
      paramOperator: [],
      selectedType: [],
      selectedOperator: [],
      isLoading: false,
      num: 0,

      selectedStartDate: dateFormatter(new Date()),
      selectedEndDate: dateFormatter(new Date()),
      companyId: this.props.auth.companyId,
      userId: this.props.auth.userId,
      roleId: this.props.auth.roleId,

    }

  }

  async componentDidMount() {
    await this.loadData();
  }

  async loadData() {
    this.setState({ isLoading: true });
    try {
      let productTypeRecords = await GetProductTypeList(this.props.auth.companyId);
      let operatorRecords = await GetOperatorList();
      let company = await GetCompanyInfoById(this.props.auth.companyId);

      let ProductTypeList = [];
      let OperatorList = [];
      let logo = (company && company.data) ? company.data.logo : "";
      let companyName = (company && company.data) ? company.data.companyName : "";

      const activePTOptions = (productTypeRecords && Array.isArray(productTypeRecords))
        ? productTypeRecords.filter(itm => itm.isActive === true)
        : [];
      const activeOPOptions = (operatorRecords && Array.isArray(operatorRecords))
        ? operatorRecords.filter(itm => itm.isActive === true)
        : [];

      activePTOptions.forEach(i => {
        ProductTypeList.push({ name: i.typeName, id: i.typeId })
      });

      activeOPOptions.forEach(i => {
        OperatorList.push({ name: i.operatorName, id: i.operatorId })
      });

      this.setState({
        ProductTypeList,
        OperatorList,
        isLoading: false,
        logo,
        companyName,
      });
    } catch (error) {
      console.error("Dashboard loadData error:", error);
      this.setState({ isLoading: false });
    }
  }


  TypeSelect(selectedItem) {
    this.setState({
      selectedType: selectedItem
    })
  }
  TypeRemove(remainItem) {
    this.setState({
      selectedType: remainItem,
    })
  }
  OperatorSelect(selectedItem) {
    this.setState({
      selectedOperator: selectedItem
    })
  }
  OperatorRemove(remainItem) {
    this.setState({
      selectedOperator: remainItem,
    })
  }

  submitHandle() {
    const typeIds = this.state.selectedType.map(t => t.id);
    const operatorIds = this.state.selectedOperator.map(o => o.id);
    this.setState({
      num: Math.floor(Math.random() * 100) + 1,
      selectedStartDate: dateFormatter(this.state.startDate),
      selectedEndDate: dateFormatter(this.state.endDate),
      selectedType: this.state.selectedType,
      selectedOperator: this.state.selectedOperator,
      paramType: typeIds,
      paramOperator: operatorIds,
    });
  }



  updateState(prop, value) {
    this.setState({ [prop]: value });
  }

  render() {

    let { ProductTypeList, selectedType } = this.state;
    let { OperatorList, selectedOperator } = this.state;
    return (
      <Row>
        <Col>
          {this.state.isLoading && <LoadingSpinner />}
          <div className='bg-light'>
            <Row className="py-2 text-center"  >
            <Col lg="4" className="text-center">
    <div className="mb-3">
        <span
            style={{
                fontWeight: 700,
                fontSize: 17,
                color: "#495057"
            }}
        >
            Company :
        </span>

        <span
            className="ml-2"
            style={{
                fontSize: 18,
                fontWeight: 600,
                color: "#3f51b5"
            }}
        >
            {this.props.auth ? this.state.companyName : ""}
        </span>
    </div>

    <img
        src={this.state.logo || defaultLogo}
        width="120"
        height="120"
        alt="Company Logo"
        draggable="false"
        style={{
            borderRadius: 10,
            border: "1px solid #ddd",
            padding: 5,
            objectFit: "contain"
        }}
    />
</Col>
              <Col lg="8" md="6" sm="12">

                <FormGroup row className='mb-4 text-left'>
                  <Label for="productType" className='col-sm-2 col-form-label font-weight-bold'>Product Type </Label>
                  <Col sm={9}>
                    <Multiselect
                      isObject="true"
                      displayValue='name'
                      placeholder={selectedType.length === 0 ? 'Select Type' : ''}
                      selectedValues={selectedType}
                      options={ProductTypeList}
                      onRemove={(item) => this.TypeRemove(item)}
                      onSelect={(item) => this.TypeSelect(item)}
                    />
                  </Col>
                </FormGroup>

                <FormGroup row className='mb-4 text-left'>
                  <Label for="operator" className="col-sm-2 col-form-label font-weight-bold">Operator</Label>
                  <Col sm={9}>
                    <Multiselect
                      isObject="true"
                      displayValue="name"
                      placeholder={selectedOperator.length === 0 ? "Select Operator" : ""}
                      selectedValues={selectedOperator}
                      options={OperatorList}
                      onRemove={(item) => this.OperatorRemove(item)}
                      onSelect={(item) => this.OperatorSelect(item)}
                    />
                  </Col>

                </FormGroup>

                <Col sm={10}>
                  <Label className='font-weight-bold text-left'>Start Date :</Label>
                  <DatePicker
                    className="btn btn-outline-dark px-2 py-2 custom-width mb-2 ml-3 h-25 mr-5 pt-2 pb-2"
                    popperPlacement="bottom-start"
                    dateFormat="dd/MM/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    yearDropdownItemNumber={3}
                    value={this.state.startDate}
                    selected={this.state.startDate}
                    onChange={(date) => this.updateState('startDate', date)}
                  />

                  <Label className='font-weight-bold'>End Date :</Label>
                  <DatePicker
                    className="btn btn-outline-dark px-2 py-2 custom-width mb-2 ml-3 mr-5 pt-2 pb-2"
                    popperPlacement="bottom-start"
                    dateFormat="dd/MM/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    yearDropdownItemNumber={3}
                    value={this.state.endDate}
                    selected={this.state.endDate}
                    onChange={(date) => this.updateState('endDate', date)}
                  />

                  <div className='float-right'>
                    <Button style={{ width: 60, height: 40, color: "#ffffff", backgroundColor: "#8a91f5" }} onClick={() => this.submitHandle()}>
                      <i className="fa fa-search" aria-hidden="true"></i>
                    </Button>
                  </div>
                </Col>


              </Col>
            </Row>
          </div>

          &nbsp;&nbsp;&nbsp;&nbsp;
          {/* <div>
          <TestChart/>
        </div> */}
          <Row>
            <Col lg="12" md="12" sm="12" className="mb-4">
              {(this.props.auth.roleId === 4) ?
                ""
                : ((this.state.num === 0) ?
                  <SalePerson DataFromDashboard={this.state} />
                  :
                  <SalePerson key={this.state.num} DataFromDashboard={this.state} />
                )
              }
            </Col>

            <Col lg="6" md="6" sm="12" className="mb-4">
              {(this.state.num === 0) ?
                <TopCounter DataFromDashboard={this.state} />
                :
                <TopCounter key={this.state.num} DataFromDashboard={this.state} />
              }
            </Col>
            <Col lg="6" md="6" sm="12" className="mb-4">
              {(this.state.num === 0) ?
                <LowestCounter DataFromDashboard={this.state} />
                :
                <LowestCounter key={this.state.num} DataFromDashboard={this.state} />
              }
            </Col>

            <Col lg="4" md="6" sm="12" className="mb-4">
              {(this.state.num === 0) ?
                <OperatorComparison DataFromDashboard={this.state} />
                :
                <OperatorComparison key={this.state.num} DataFromDashboard={this.state} />
              }
            </Col>
            <Col lg="8" md="6" sm="12" className="mb-4">
              {(this.state.num === 0) ?
                <ProductTypeOperator DataFromDashboard={this.state} />
                :
                <ProductTypeOperator key={this.state.num} DataFromDashboard={this.state} />
              }
            </Col>
          </Row>
        </Col>
      </Row>

    );
  }
}
function mapStateToProps(state) {
  return { auth: state.auth };
}
export default connect(mapStateToProps)(Dashboard);
